import type { Questionnaire } from '@medplum/fhirtypes'
import {
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'

export const homeCareUtilizationQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/home-care-utilization',
  title: 'Home Care Utilization',
  name: 'Home Care Utilization',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: 'bathing',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '45',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 45,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '45',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 45,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '45',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 45,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'bathing-per-week',
      type: 'integer',
    },
    {
      linkId: 'bathing-per-day',
      type: 'integer',
    },
    {
      linkId: 'dressing-grooming',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'dressing-grooming-per-week',
      type: 'integer',
    },
    {
      linkId: 'dressing-grooming-per-day',
      type: 'integer',
    },
    {
      linkId: 'toileting',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'toileting-per-week',
      type: 'integer',
    },
    {
      linkId: 'toileting-per-day',
      type: 'integer',
    },
    {
      linkId: 'ambulation-transfers',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'ambulation-transfers-per-week',
      type: 'integer',
    },
    {
      linkId: 'ambulation-transfers-per-day',
      type: 'integer',
    },
    {
      linkId: 'eating',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'eating-per-week',
      type: 'integer',
    },
    {
      linkId: 'eating-per-day',
      type: 'integer',
    },
    {
      linkId: 'meal-preparation',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '30',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 30,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'meal-preparation-per-week',
      type: 'integer',
    },
    {
      linkId: 'meal-preparation-per-day',
      type: 'integer',
    },
    {
      linkId: 'medication-reminders',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '15',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 15,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'medication-reminders-per-week',
      type: 'integer',
    },
    {
      linkId: 'medication-reminders-per-day',
      type: 'integer',
    },
    {
      linkId: 'laundry',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'laundry-per-week',
      type: 'integer',
    },
    {
      linkId: 'light-housekeeping',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'light-housekeeping-per-week',
      type: 'integer',
    },
    {
      linkId: 'grocery-shopping-errands',
      type: 'choice',
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            code: 'independent',
            display: 'Independent',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'minimally-dependent',
            display: 'Requires minimal assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'moderately-dependent',
            display: 'Requires moderate assistance',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '60',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 60,
            },
          ],
          valueCoding: {
            code: 'dependent',
            display: 'Dependent',
          },
        },
      ],
    },
    {
      linkId: 'grocery-shopping-errands-per-week',
      type: 'integer',
    },
    {
      linkId: 'other-domestic-services-notes',
      type: 'text',
    },
    {
      linkId: 'other-domestic-services-hours',
      type: 'decimal',
    },
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire
